import { ThrowStmt } from "@angular/compiler";

export class TransactionStatusQueryParams {
    status: boolean;
    refid: string;
    amount: number;
    cardno: string;

    constructor(
        status: string,
        refid: string,
        amount: string,
        cardno: string
    ) {
        // cast status to boolean
        this.status = status === 'true' ? true : false;

        // cas amount to number
        this.amount = amount ? parseInt(amount, 10) : null;

        // let cardno remain as string
        this.cardno = cardno;

        // let ref remain as string
        this.refid = refid;
    }
}
